import { ContractsUploadModal } from './ContractsUploadModal';
import { SupplierInvoicesUploadModal } from './SupplierInvoicesUploadModal';
import { UploadFilesModal } from './UploadFilesModal';
import type { useAkteUploads } from './useAkteUploads';

/** Bündelt die drei Upload-Modals, gespeist aus dem useAkteUploads-Routing. */
export function AkteUploadModals({ uploads }: { uploads: ReturnType<typeof useAkteUploads> }) {
  const { generic, contracts, invoices, setGeneric, setContracts, setInvoices } = uploads;

  return (
    <>
      <UploadFilesModal
        open={generic.open}
        onOpenChange={(open) => setGeneric((s) => ({ ...s, open }))}
        onUpload={uploads.uploadFile}
        defaultKind={generic.meta?.defaultKind ?? 'Sonstiges'}
        contextLabel={generic.meta?.title ?? 'Akte'}
        initialFiles={generic.files}
        targetFolder={generic.targetFolder}
      />

      <ContractsUploadModal
        open={contracts.open}
        onOpenChange={(open) => setContracts((s) => ({ ...s, open }))}
        initialFiles={contracts.files}
        onUpload={uploads.uploadContract}
      />

      <SupplierInvoicesUploadModal
        open={invoices.open}
        onOpenChange={(open) => setInvoices((s) => ({ ...s, open }))}
        initialFiles={invoices.files}
        onUpload={uploads.uploadInvoice}
      />
    </>
  );
}
